module.exports = __webpack_public_path__ + "img/panel-theme.db3ac057.svg";